import KeyMirror from 'keymirror';

export const ActionTypes = KeyMirror({
  APP_RESET: null,
  APP_SOFT_RESET: null,
  APP_RECEIVE_USER_DATA: null,
  APP_RECEIVE_ORGANIZATIONS_DATA: null,
  APP_RECEIVE_METADATA: null,
  APP_RECEIVE_OPTIONS: null,
  APP_RECEIVE_IMAGE_DIMENSIONS_KEY: null,
  APP_RECEIVE_TWITTER_AUTOCOMPLETE_BOOTSTRAP_DATA: null,
  COMPOSER_HIDE_SUGGESTED_MEDIA: null,
  COMPOSER_UPDATE_DRAFTS_THREAD: null,
  COMPOSER_UPDATE_DRAFT_THREAD: null,
  COMPOSER_UPDATE_DRAFT_ADD_TWEET: null,
  COMPOSER_SET_ACTIVE_THREAD_ID: null,
  COMPOSER_SWITCH_ACTIVE_THREAD_EDITOR: null,
  COMPOSER_DELETE_THREADED_DRAFT: null,
  COMPOSER_CREATE_PROFILES: null,
  COMPOSER_SET_DRAFTS_INITIAL_TEXT: null,
  COMPOSER_UPDATE_DRAFT_EDITOR_STATE: null,
  COMPOSER_UPDATE_TOGGLE_SIDEBAR: null,
  COMPOSER_UPDATE_DRAFT_CHARACTER_COUNT: null,
  COMPOSER_UPDATE_DRAFT_COMMENT: null,
  COMPOSER_UPDATE_DRAFT_SHOPGRID_LINK: null,
  COMPOSER_UPDATE_DRAFT_COMMENT_CHARACTER_COUNT: null,
  COMPOSER_UPDATE_DRAFT_TITLE_CHARACTER_COUNT: null,
  COMPOSER_UPDATE_DRAFT_SOURCE_LINK: null,
  COMPOSER_UPDATE_DRAFTS_SOURCE_LINK: null,
  COMPOSER_UPDATE_DRAFT_SOURCE_LINK_DATA: null,
  COMPOSER_UPDATE_DRAFT_TITLE: null,
  COMPOSER_UPDATE_DRAFT_UPDATE_TYPE: null,
  COMPOSER_UPDATE_DRAFT_GOOGLE_BUSINESS_DATA: null,
  COMPOSER_UPDATE_DRAFT_INSTAGRAM_DATA: null,
  COMPOSER_UPDATE_DRAFT_YOUTUBE_DATA: null,
  COMPOSER_UPDATE_DRAFTS_TITLE: null,
  COMPOSER_UPDATE_DRAFT_START_PAGE_DATA: null,
  COMPOSER_UPDATE_DRAFT_LINK_DATA: null,
  COMPOSER_UPDATE_DRAFTS_LINK_DATA: null,
  COMPOSER_UPDATE_DRAFT_LOCATION: null,
  COMPOSER_UPDATE_DRAFTS_LOCATION: null,
  COMPOSER_UPDATE_DRAFT_LIST_PLACES: null,
  COMPOSER_UPDATE_DRAFTS_COMMENT: null,
  COMPOSER_UPDATE_DRAFTS_SHOPGRID_LINK: null,
  COMPOSER_UPDATE_DRAFTS_UPDATE_TYPE: null,
  COMPOSER_PARSE_MASTODON_TEXT: null,
  COMPOSER_ADD_DRAFT_IMAGE: null,
  COMPOSER_DRAFT_IMAGE_ADDED: null,
  COMPOSER_REMOVE_DRAFT_IMAGE: null,
  APP_SELECT_SUBPROFILE: null,
  APP_SELECT_SUBPROFILES: null,
  APP_UNSELECT_SUBPROFILE: null,
  COMPOSER_ADD_DRAFT_VIDEO: null,
  COMPOSER_ADD_DRAFT_GIF: null,
  COMPOSER_DRAFT_VIDEO_ADDED: null,
  COMPOSER_DRAFT_GIF_ADDED: null,
  COMPOSER_REMOVE_DRAFT_VIDEO: null,
  COMPOSER_REMOVE_DRAFT_GIF: null,
  COMPOSER_UPDATE_DRAFT_TEMP_IMAGE: null,
  COMPOSER_REMOVE_DRAFT_TEMP_IMAGE: null,
  COMPOSER_ADD_DRAFTS_RETWEET: null,
  COMPOSER_SAVE_DRAFTS: null,
  COMPOSER_RECEIVE_SAVED_DRAFTS: null,
  COMPOSER_SELECT_PROFILES_ON_BEHALF_OF_USER: null,
  COMPOSER_SELECT_PROFILE: null,
  COMPOSER_SELECT_PROFILES: null,
  COMPOSER_QUEUE_PROFILES_SUBPROFILES_DROPDOWNS_TO_EXPAND: null,
  COMPOSER_EMPTY_PROFILES_SUBPROFILES_DROPDOWNS_TO_EXPAND: null,
  COMPOSER_UNSELECT_PROFILE: null,
  COMPOSER_UNSELECT_PROFILES: null,
  COMPOSER_EXPAND: null,
  COMPOSER_COLLAPSE: null,
  COMPOSER_TOGGLE_DRAFT_ATTACHMENT: null,
  COMPOSER_DISABLE_DRAFT_ATTACHMENT: null,
  COMPOSER_ENABLE_DRAFTS_ATTACHMENT: null,
  COMPOSER_DRAFT_ATTACHMENT_TOGGLED: null,
  COMPOSER_ENABLE: null,
  COMPOSER_DISABLE: null,
  COMPOSER_PARSE_DRAFT_TEXT_LINKS: null,
  COMPOSER_PARSE_DRAFTS_TEXT_LINKS: null,
  COMPOSER_DRAFT_LINK_SHORTENED: null,
  COMPOSER_DRAFT_LINK_UNSHORTENED: null,
  COMPOSER_DRAFT_LINK_RESHORTENED: null,
  COMPOSER_ADD_DRAFT_AVAILABLE_IMAGES: null,
  COMPOSER_REMOVE_DRAFT_AVAILABLE_IMAGES: null,
  COMPOSER_DRAFT_FILE_UPLOAD_STARTED: null,
  COMPOSER_DRAFT_FILE_UPLOAD_PROGRESS: null,
  COMPOSER_ADD_DRAFT_UPLOADED_IMAGE: null,
  UPLOADED_LINK_THUMBNAIL: null,
  COMPOSER_ADD_DRAFTS_AUTO_UPLOADED_IMAGE: null,
  COMPOSER_ADD_DRAFT_UPLOADED_GIF: null,
  COMPOSER_ADD_DRAFTS_AUTO_UPLOADED_GIF: null,
  COMPOSER_ADD_DRAFT_UPLOADED_VIDEO_WITHOUT_TRANSCODING: null,
  COMPOSER_ADD_DRAFT_UPLOADED_VIDEO: null,
  COMPOSER_ADD_DRAFTS_AUTO_UPLOADED_VIDEO: null,
  COMPOSER_VIDEO_PROCESSED: null,
  COMPOSER_UPDATE_DRAFTS_SCHEDULED_AT: null,
  COMPOSER_UPDATE_DRAFT_CAMPAIGN_ID: null,
  COMPOSER_UPDATE_DRAFTS_CAMPAIGN_ID: null,
  COMPOSER_UPDATE_DRAFT_IMAGE_USER_TAGS: null,
  COMPOSER_UPDATE_DRAFTS_IMAGE_USER_TAGS: null,
  COMPOSER_CREATE_NEW_SUBPROFILE: null,
  COMPOSER_CREATE_NEW_SUBPROFILE_PENDING: null,
  COMPOSER_CREATE_NEW_SUBPROFILE_FAILED: null,
  PROFILE_DROPDOWN_HIDDEN: null,
  COMPOSER_COLLAPSE_PROFILE_SUBPROFILE_DROPDOWN: null,
  COMPOSER_EXPAND_PROFILE_SUBPROFILE_DROPDOWN: null,
  APP_SELECT_GROUP_PROFILES: null,
  APP_UNSELECT_GROUP_PROFILES: null,
  COMPOSER_PROFILE_GROUP_CREATED: null,
  COMPOSER_PROFILE_GROUP_UPDATED: null,
  COMPOSER_PROFILE_GROUP_DELETED: null,
  APP_RECEIVE_PROFILE_SLOT_DATA: null,
  QUEUE_NOTIFICATION: null,
  REMOVE_NOTIFICATION: null,
  REMOVE_NOTIFICATION_COOKIE: null,
  APP_TOGGLE_ALL_PROFILES: null,
  APP_REFRESH_SUBPROFILE_DATA: null,
  COMPOSER_ADD_DRAFT_UPLOADED_LINK_THUMBNAIL: null,
  COMPOSER_UPDATE_DRAFT_LINK_THUMBNAIL: null,
  COMPOSER_UPDATE_DRAFT_VIDEO_THUMBNAIL: null,
  COMPOSER_UPDATE_DRAFT_VIDEO_TITLE: null,
  COMPOSER_UPDATE_PREVIOUS_LINK_THUMBNAIL: null,
  COMPOSER_UPDATE_NEXT_LINK_THUMBNAIL: null,
  UPDATE_DRAFT_HAS_SAVING_ERROR: null,
  COMPOSER_CLEAR_INLINE_ERRORS: null,
  UPDATE_DRAFT_IS_SAVED: null,
  APP_LOADED: null,
  COMPOSER_APPLY_OMNI_UPDATE: null,
  REMOVE_ALL_NOTIFICATIONS_BY_SCOPE: null,
  REMOVE_COMPOSER_NOTICES: null,
  COMPOSER_UPDATE_IMAGE_ALT_TEXT: null,
  COMPOSER_UPDATE_UPLOADED_IMAGE_DIMENSIONS: null,
  COMPOSER_DRAFTS_PREVENT_AUTO_ATTACHING_URLS: null,
  COMPOSER_FORCE_FOCUS: null,
  COMPOSER_STOP_FORCE_FOCUS: null,
  RESET_PROFILES_DATA: null,
  UPDATE_SELECTED_PROFILES: null,
  APP_REFRESH_FACEBOOK_DOMAIN_OWNERSHIP_DATA: null,
  APP_RECEIVE_FACEBOOK_DOMAIN_OWNERSHIP_DATA: null,
  APP_UPDATE_OMNIBOX_STATE: null,
  APP_UPDATE_PARTIALLY_SAVED_DRAFTS_PROFILES_IDS: null,
  COMPOSER_UPDATE_INSTAGRAM_STATE: null,
  APP_REMEMBER_TWITTER_MAX_PROFILE_NOTIF_CLOSED_ONCE: null,
  EVENT_SHOW_SWITCH_PLAN_MODAL: null,
  COMPOSER_UPDATE_INSTAGRAM_DRAFT_THUMBNAIL: null,
  COMPOSER_UPDATE_DRAFT_THUMBNAIL_GENERATED: null,
  APP_SET_THUMBNAIL_LOADING: null,
  RESET_ORGANIZATIONS_DATA: null,
  COMPOSER_UPDATE_HASHTAG_PAYWALL: null,
  UPDATE_CONNECT_CHANNEL_POPOVER_VISIBLE: null,
  COMPOSER_INSERT_HASHTAG_TO_CAPTION: null,
  COMPOSER_UPDATE_TOGGLE_POST_PREVIEW: null,
  // composer modal action types
  CLOSE_MODAL: null,
  OPEN_MODAL: null,
  SET_APP_NOTIFICATION_MESSAGE: null,
  COMPOSER_UPDATE_INSTAGRAM_DRAFTS_FEEDBACK: null,
});
